import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { VehicleService } from '../../../services/vehicle/vehicle.service';
import { InventoryCar } from '../../../shared/models/car.interface';
import { DestructorComponent } from '../../../components/destructor/destructor.component';

declare var bootstrap: any;

@Component({
  selector: 'app-vh-inventory-detail',
  templateUrl: './vh-inventory-detail.component.html',
  styleUrls: ['./vh-inventory-detail.component.scss']
})
export class VhInventoryDetailComponent extends DestructorComponent implements OnInit, OnDestroy {

  // Data properties
  vehicle: InventoryCar | null = null;
  vehicleId: string | null = null;

  // State properties
  isLoading: boolean = false;

  constructor(
    private _vehicleService: VehicleService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.setupModalListener();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  private setupModalListener(): void {
    const modalElement = document.getElementById('kt_modal_vh_inventory_detail');
    if (modalElement) {
      modalElement.addEventListener('shown.bs.modal', () => {
        const selectedVehicleId = (window as any).selectedVehicleIdForDetail;
        if (selectedVehicleId) {
          this.vehicleId = selectedVehicleId;
          this.loadVehicleDetails(selectedVehicleId);
        } else {
          this.resetModal();
        }
      });

      modalElement.addEventListener('hidden.bs.modal', () => {
        this.resetModal();
        (window as any).selectedVehicleIdForDetail = null;
      });
    }
  }

  private loadVehicleDetails(vehicleId: string): void {
    this.isLoading = true;
    this.vehicle = null;

    this.subscriptions.push(
      this._vehicleService.GetInventoryDetailsById(vehicleId).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          if (response.status && response.data) {
            this.vehicle = response.data;
          } else {
            console.error('Failed to load vehicle details');
          }
          this.cdr.detectChanges();
        },
        error: (error: any) => {
          this.isLoading = false;
          console.error('Error loading vehicle details:', error);
          this.cdr.detectChanges();
        }
      })
    );
  }

  private resetModal(): void {
    this.vehicle = null;
    this.vehicleId = null;
    this.isLoading = false;
  }

  closeModal(): void {
    const modalElement = document.getElementById('kt_modal_vh_inventory_detail');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
  }

  // Helper methods for displaying data
  formatMileage(mileage: number): string {
    if (!mileage) return '-';
    return mileage.toLocaleString() + ' km';
  }

  formatPrice(price: number): string {
    if (!price) return '-';
    return '¥' + price.toLocaleString();
  }

  formatDate(dateString: string): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString();
  }

  // Get display value or fallback
  getDisplayValue(value: any, fallback: string = '-'): string {
    return value || fallback;
  }

  getTotalAuctionPrice(price_sheet:any){

    if(!price_sheet) return 0;

    return price_sheet.description.auction_price?.actual + price_sheet.description.auction_price_tax?.actual || 0;

  }

  getTotalBidCharge(price_sheet:any){

    if(!price_sheet) return 0;

    return price_sheet.description.bid_charge?.actual + price_sheet.description.bid_price_tax?.actual || 0;

  }
}
